import {
  ApprovalState,
  FieldValueEntryPayloadModel,
  GetWorkOrders_V1Query,
  Maybe,
  TeamPayloadModel,
  ValueType,
} from './gql/graphql';

import type { AppointmentTypeSelection } from './common/calendar';

// This order should be kept. Order is being used in the search
// export enum WorkOrderStatus {
//   IN_PROGRESS = 'inProgress',
//   PAUSED = 'pause',
//   CANCELED = 'cancelled',
//   OPEN = 'open',
//   COMPLETED = 'completed',
// }

export enum WorkGroupStatus {
  OPEN = 'open',
  SUBMITTED = 'submitted',
  IN_PROGRESS = 'inProgress',
  REJECTED = 'rejected',
  RESUBMITTED = 'resubmitted',
  APPROVED = 'approved',
}

export enum WorkOrderType {
  SOLAR = 'solar',
  SOLARPAKET = 'solarpaket',
  MAINTENANCE = 'maintenance',
  VOT = 'vot',
}

export enum WorkItemCategory {
  AC = 'ac',
  DC = 'dc',
}

export enum TeamSkills {
  AC = 'ac',
  DC = 'dc',
  VOT = 'vot',
}

export enum WorkItemGroup {
  SITE_SETUP = 'siteSetup',
  ROOF_MOUNTING = 'roofMounting',
  FLEXING_ROOF_TILES = 'flexingRoofTiles',
  MONTAGE_UK = 'montageUk',
}

export enum WorkCategoryOverviewStatus {
  OPEN = 'open',
  STARTED = 'started',
  IN_PROGRESS = 'inProgress',
  PAUSED = 'paused',
  CANCELLED = 'cancelled',
  SUBMITTED = 'submitted',
  RESUBMITTED = 'resubmitted',
  COMPLETED = 'completed',
}

export enum UserRoles {
  ADMIN = 'admin',
  PROJECT_MANAGER = 'projectManager',
  QUALITY_MANAGER = 'qualityManager',
  CRAFTSMAN = 'craftsman',
}

export type WorkOrdersType = SingleWorkOrderType[];

export type SingleWorkOrderType = {
  clientName: string;
  groups: WorkGroupsType[];
  id: string;
  progress: number;
  projectManager: string;
  qualityManager: string;
  startDate: Date;
  status: ApprovalState;
  team: TeamPayloadModel;
  workOrder: WorkOrderType;
};

export type WorkGroupsType = {
  id: string;
  items: {
    items: WorkGroupItemsType[];
    title: WorkItemGroup;
  }[];
  startDate: string;
  status: ApprovalState;
  title: WorkItemCategory;
};

export type WorkGroupItemsType = { status: ApprovalState; workItemId: string };

export type Counter = { count: number; link?: string };

export type Issue = Counter & { status: ApprovalState };

export type WorkOrdersTypeExtend = NonNullable<GetWorkOrders_V1Query['getWorkOrders_V1']['data']>[number] & {
  issues: Array<Issue>;
  lastUpdated: Date;
};

export type WorkItemsType = {
  clientName?: string;
  id: string;
  lastUpdated?: Date;
  qualityManager: string;
  status: ApprovalState;
  submittedBy: string;
  workCategory: WorkItemCategory;
  workGroup: WorkItemGroup;
  workItem: string;
  workOrder: WorkOrderType;
  workOrderId: string;
};

export type WorkItemDetails = {
  acceptanceCriteria: MessageContent;
  documents: Document[];
  isOpened: boolean;
  messages: Message[];
  notes: Note[];
  status: ApprovalState;
  workItemName: string;
};

export type MessageContent = {
  image?: { contentType: string; url: string }[];
  isYesNo?: boolean;
  multipleChoice?: string[];
  signature?: { hasAcceptedTerms: boolean; image: { url: string } };
  text?: string;
};

export type Note = {
  authorName: string;
  createdAt: string;
  note: string;
  tags: {
    workCategory?: string;
    workGroup?: string;
    workItem?: string;
  };
};

export type NotesInitialization = {
  category: string;
  workGroup: string;
  workItem: string;
};

export type Message = {
  author?: Author;
  comment?: string | null;
  content?: MessageContent;
  // | string
  // | string[]
  // | number
  // | { url: string }[]
  // | { hasAcceptedTerms: boolean; image: { url: string } }
  // | boolean;
  date: string;
  fieldName?: string;
  id: number;
  isArray?: boolean | null;
  itemDecisions?: Array<{
    approvalState: ApprovalState;
    arrayIndex: number;
    decisionMadeAtUtc?: string | null;
    decisionMadeById?: number | null;
    mediaId?: number | null;
    rejectReason?: string | null;
  }>;
  status: ApprovalState;
  type: ValueType;
  workItemName?: string;
};

export type Entry = FieldValueEntryPayloadModel & {
  fieldName: string;
  id: string;
  isArray: Maybe<boolean> | undefined;
  type: ValueType;
};

export type Author = {
  id?: number;
  isCraftsman: boolean;
  name: string;
  team?: string;
};

export type Reason = { description: string; label: string; value: string };

export type Option<TValue = string | number | undefined> = {
  icon?: React.ReactElement;
  isDeleted?: boolean;
  label: string;
  value: TValue | undefined;
};

export type CrumbType = {
  label: string;
  slug?: string;
};

export type MoreWorkItem = {
  id: string;
  name: string;
};

export type Document = {
  id: string;
  name: string;
  url: string;
};

export type QmApiResponse = {
  data: WorkOrdersType;
  meta: {
    totalRowCount: number;
  };
};

export type TeamUser = {
  branch: string;
  email: string;
  id: string;
  isDeleted?: boolean;
  label: string;
  userRole: string;
  value: string;
};

export type TeamSkill = {
  id: number;
  name: string;
};
